<template lang="html">
	<section class="block">
		<h3>{{ $t(`${sector}.${abast}.diet.title`) }}</h3>
		<p v-if="isReportEditable" class="note">{{ $t(`${sector}.${abast}.diet.desc`) }}</p>
		<emissions-table v-if="!skip" v-model="emissions" :editable="isReportEditable">
			<template v-slot:header>
				<th>{{ $t('report.table.concept') }}</th>
				<th>{{ $t('report.table.diet') }}</th>
				<th>{{ $t('report.table.people') }}</th>
			</template>
			<template v-slot:body="{ item }">
				<td>{{ item.concept }}</td>
				<td>{{ item.resource.label }}</td>
				<td>{{ item.qty }}<em class="unit">{{ item.resource.unit }}</em></td>
			</template>
			<template v-slot:insert="{ insert }">
				<td>
					<input
						type="text"
						class="long"
						v-model="insert.concept"
						:placeholder="$t(`${sector}.${abast}.diet.example`)" />
				</td>
				<td>
					<dropdown-select
						:options="DIETS"
						v-model="insert.resource"
						:placeholder="$t('report.table.diet')" />
				</td>
				<td :data-tooltip="isEmpty(insert.resource)
					? $t('tooltip.require.diet')
					: $t('tooltip.unit_in', { unit: insert.resource.unit })">
					<input
						v-model.number="insert.qty"
						:disabled="isEmpty(insert.resource)"
						:placeholder="isEmpty(insert.resource)
							? $t('report.table.people')
							: insert.resource.unit"
						type="number"
						min="0"
						step="0.1" />
				</td>
			</template>
		</emissions-table>
		<p v-if="isSkipperVisible">
			<label>
				<input type="checkbox" v-model="skip" :disabled="!isReportEditable" />
				{{ $t('global.tip.skip') }}
			</label>
		</p>
	</section>
</template>

<script>
import StepBlockMixin from '@/mixins/StepBlockMixin';
import EmissionsTable from '@/components/EmissionsTable.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';
import { isEmpty } from '@/utils';
import DIETS from '@/assets/constants/diets';

export default {
	name: 'StepDiet',
  keyBlock: 'diet',
	mixins: [StepBlockMixin],
	components: { EmissionsTable, DropdownSelect },
	data() {
		return { DIETS };
	},
	methods: { isEmpty },
};
</script>
